import { render, $ } from "../lib/ui";
import { icons } from "../lib/icons";

export interface IncomingHandlers {
  callerCode: string;
  onAccept: () => void;
  onDecline: () => void;
}

export function showIncoming({
  callerCode,
  onAccept,
  onDecline,
}: IncomingHandlers): void {
  const initial = callerCode.charAt(0).toUpperCase();
  render(`
    <div class="screen incoming">
      <div class="call-bg"></div>
      <div class="who">
        <div class="avatar">${initial}</div>
        <div class="caller">${callerCode}</div>
        <div class="status">is calling you…</div>
      </div>
      <div class="controls">
        <button class="ctrl end" id="decline" title="Decline">${icons.hangup}</button>
        <button class="ctrl accept" id="accept" title="Accept">${icons.phone}</button>
      </div>
    </div>
  `);

  $("#accept").addEventListener("click", onAccept);
  $("#decline").addEventListener("click", onDecline);
}
